import FormItem from 'components/Form/FormItem';
import { authJsonPost } from 'functions/BaseAxios';
import { getGiveaway, getGiveawayCheck, getGiveawayDetail, getGiveawayDetailUser, getGiveawayJobs, postVoteGiveawayDetail, showAlertGiveaway } from 'functions/redux/giveaway/action';
import { RootStore } from 'functions/redux/store';
import React, { FC, Fragment, useEffect, useState } from 'react'
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import Avatar from 'shared/Avatar/Avatar';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import Input from 'shared/Input/Input';
import imageCompression from 'browser-image-compression'
import Textarea from 'shared/Textarea/Textarea';
import { Tab } from '@headlessui/react';
import TableCustom from 'components/Table/tableCustom';
import { HeartIcon } from '@heroicons/react/solid';
import { HeartIcon as HeartIconOutline } from '@heroicons/react/outline';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import ButtonThird from 'shared/Button/ButtonThird';
import ButtonSecondary from 'shared/Button/ButtonSecondary';
import NcModal from 'shared/NcModal/NcModal';

export interface AuthorPagePros {
    className?: string;
}

const PageGiveaway: FC<AuthorPagePros> = ({ className = "" }) => {
    const dispatch = useDispatch();
    const { giveawayReducer } = useSelector((state: RootStore) => state)
    const { user, general } = useSelector((state: RootStore) => state);
    const history = useHistory();
    const [loading, setLoading] = React.useState("");

    const search = useLocation().search;
    const param = new URLSearchParams(search).get("q");

    const [name, setName] = useState<string>("");
    const [idDetail, setIdDetail] = useState<string>("");
    const [instagram, setinstagram] = useState<string>("");
    const [note, setNote] = useState<string>("");
    const [textJob, settextJob] = useState<any>("");
    const [nameJob, setnameJob] = useState("");
    const [typeJob, setTypeJob] = useState("");
    const [imageShow, setImageShow] = useState<any>(null)
    const [prevImage, setPrevImage] = useState<any>({})

    const [nameJobImg, setnameJobImg] = useState("");
    const [typeJobImg, setTypeJobImg] = useState("");
    const [imageFile, setImageFile] = useState<any>(null);

    const [showButton, setShowButton] = useState<any>(null);
    const [showPrevImg, setshowPrevImg] = useState<any>(null);

    const [maxVote, setMaxVote] = useState<number>(0);
    const [availableVote, setAvailableVote] = useState<number>(0)

    const [checkData, setCheckData] = useState<boolean>(false)
    const [checkExpired, setCheckExpired] = useState<boolean>(false)
    const [stateGiveway, setStateGiveway] = useState<boolean>(false)
    const [loadingRefresh, setLoadingRefresh] = useState<boolean>(false)
    const [loadingVote, setLoadingVote] = useState<number | null>(null)

    useEffect(() => {
        dispatch(getGiveaway(param?.toString()))
        dispatch(getGiveawayCheck(param?.toString()))
        dispatch(getGiveawayDetail(param?.toString()))
    }, [param])

    useEffect(() => {
        if (user?.credential === 'LOGIN_FALSE') {
            history.push('/login')
        }
    }, [user.credential])

    useEffect(() => {
        if (giveawayReducer.giveawayCheck?.id) {
            setName(giveawayReducer.giveawayCheck.name);
            setinstagram(giveawayReducer.giveawayCheck.account)
            setNote(giveawayReducer.giveawayCheck.note)
            setIdDetail(giveawayReducer.giveawayCheck?.id)
            dispatch(getGiveawayJobs(giveawayReducer.giveawayCheck?.id))
            setCheckData(true);
        }

    }, [giveawayReducer.giveawayCheck])

    useEffect(() => {
        setAvailableVote(maxVote - giveawayReducer.giveawayDetail?.count)
        setLoadingVote(null)
    }, [giveawayReducer.giveawayDetail, maxVote])



    useEffect(() => {
        setMaxVote(giveawayReducer.giveawayData?.maxVote)
        if (giveawayReducer.giveawayData) {
            setStateGiveway(giveawayReducer.giveawayData?.status)

            let endDateOrigin = moment(new Date(giveawayReducer.giveawayData.endDate)).format('YYYY-MM-DD 23:59:59');
            let endDate = moment(endDateOrigin);
            let now = moment().format('YYYY-MM-DD 23:59:59');
            let diff = endDate.diff(moment(now), 'days');

            if (diff < 0) {
                setCheckExpired(true)
            }

        }
    }, [giveawayReducer.giveawayData])

    useEffect(() => {
        if (checkData === false && checkExpired) {
            toast('Giveaway Expired');
        }

    }, [checkData, checkExpired])


    const refreshTable = async () => {
        setLoadingRefresh(true)
        await dispatch(getGiveawayDetail(param?.toString()))
        setLoadingRefresh(false)
    }


    const postVote = async (id: number, stat: boolean) => {

        if (stateGiveway === false) {
            toast('Giveaway Non Active');
            setLoadingVote(null)
            return;

        }

        if (checkExpired) {
            toast('Giveaway Expired');
            setLoadingVote(null)
            return;
        }

        if (stat == true) {
            if (availableVote == 0) {
                toast("you can't vote again")
                setLoadingVote(null)
                return false;
            }
        }

        if (loadingVote != null) {
            toast("Please wait")
            setLoadingVote(id);
            return false;
        }
        dispatch(postVoteGiveawayDetail(id, stat))

    }
    const submitdata = async () => {
        setLoading('submit')
        if (stateGiveway === false) {
            toast('Giveaway Non Active');
            setLoading("");

            return;

        }
        if (checkExpired) {
            toast('Giveaway Expired');
            setLoading("");

            return;
        }
        if (name == '') {
            toast('Name can not empty');
            setLoading("");

            return;
        }
        if (instagram == '') {
            toast('Instagram can not empty');
            setLoading("");

            return;
        }

        if (loading !== "submit") {
            try {
                let newData = {
                    name: name,
                    account: instagram,
                    note: note,
                    id: idDetail,
                    q: param
                }

                await authJsonPost(newData, 'auth/giveaway/submit');
                dispatch(getGiveawayCheck(param?.toString()))
                dispatch(getGiveawayDetailUser())
                setLoading("");
                refreshTable()
            } catch (error) {
                setLoading("");
            }
        }
    }


    const sendData = async () => {
        if (stateGiveway === false) {
            toast('Giveaway Non Active');

            return;

        }
        if (checkExpired) {
            toast('Giveaway Expired');

            return;
        }
        if (textJob == '') {
            toast('Field can not empty');
            return;
        }
        if (loading !== "submitJob") {
            setLoading('submitJob')
            try {
                var formData = new FormData();
                formData.append('name', nameJob);
                formData.append('type', typeJob);
                formData.append('text', textJob);
                formData.append('image', imageFile);
                formData.append('detail', giveawayReducer.giveawayCheck.id);

                await authJsonPost(formData, 'auth/giveaway/submit-job');
                await dispatch(getGiveawayJobs(giveawayReducer.giveawayCheck?.id))
                setLoading("");
                setShowButton(null);

            } catch (error) {
                setLoading("");
            }
        }

    }

    const sendDataImage = async () => {
        if (stateGiveway === false) {
            toast('Giveaway Non Active');

            return;

        }
        if (checkExpired) {
            toast('Giveaway Expired');

            return;
        }
        if (imageFile == null) {
            return;
        }
        if (loading !== "submitImg") {
            setLoading('submitImg')
            try {
                var formData = new FormData();
                formData.append('name', nameJobImg);
                formData.append('type', typeJobImg);
                formData.append('text', imageFile);
                formData.append('detail', giveawayReducer.giveawayCheck.id);

                await authJsonPost(formData, 'auth/giveaway/submit-job');
                dispatch(getGiveawayJobs(giveawayReducer.giveawayCheck?.id))
                setLoading("");

            } catch (error) {
                setLoading("");
            }
        }

    }


    const renderSidebar = () => {
        return (
            <div className=" w-full flex flex-col items-center text-center sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-7 px-0 sm:p-6 xl:p-8">
                <Avatar
                    hasChecked={user.credential?.isGuide ?? false}
                    imgUrl={user.credential?.profile?.avatar}
                    hasCheckedClass="w-6 h-6 -top-0.5 right-2"
                    sizeClass="w-28 h-28"
                />

                <div className="space-y-3 text-center flex flex-col items-center">
                    <h2 className="text-3xl font-semibold">{user.credential?.profile?.displayName}</h2>
                </div>

                <p className="text-neutral-500 dark:text-neutral-400">
                    {user.credential?.profile?.aboutMe ?? '---'}
                </p>

                <div className="border-b border-neutral-200 dark:border-neutral-700 w-14"></div>
            </div>
        );
    };


    const renderPage = () => {
        return (
            <div>
                <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
                    <header className="text-center max-w-2xl mx-auto ">
                        <label className="flex items-center text-md leading-[115%] text-2xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                            {giveawayReducer?.giveawayData?.name}

                        </label>
                        <span className="block text-sm text-neutral-700 sm:text-sm dark:text-neutral-200">
                            {giveawayReducer?.giveawayData?.description}
                        </span>
                    </header>
                    <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                    <div className="space-y-8">
                        <FormItem
                            label="Name"
                            desc=""
                        >
                            <Input placeholder="Insert your name" onChange={(e) => setName(e.target.value)} />
                        </FormItem>
                        <FormItem
                            label="Instagram"
                            desc=""
                        >
                            <Input placeholder="Insert your instagram" onChange={(e) => setinstagram(e.target.value)} />
                        </FormItem>
                        <FormItem
                            label="Note"
                            desc=""
                        >
                            <Textarea rows={2} placeholder={'Insert your note'} maxLength={150} onChange={(e) => {
                                setNote(e.target.value)

                            }} />
                            <span className='text-xs'>max 150 character</span>
                        </FormItem>
                    </div>
                    <div className="flex justify-end space-x-5 mt-3">
                        <ButtonPrimary onClick={submitdata}>
                            {loading === "submit" ? <div className="flex justify-center">
                                <Loader
                                    type="Circles"
                                    color="#fff"
                                    height={25}
                                    width={25}
                                />
                            </div> : 'Submit'}

                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        )
    }

    const renderPage2 = () => {
        return (
            <div>
                <div className="w-full flex flex-col sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 space-y-8 px-0 sm:p-6 xl:p-8">
                    <header className="text-center max-w-2xl mx-auto ">
                        <label className="flex items-center text-md leading-[115%] text-2xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                            {giveawayReducer?.giveawayData?.name}

                        </label>
                        <span className="block text-sm text-neutral-700 sm:text-sm dark:text-neutral-200">
                            {giveawayReducer?.giveawayData?.description}
                        </span>
                    </header>
                    <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                    <Tab.Group>
                        <Tab.List className="flex relative space-x-1 overflow-x-auto">
                            {["Your", "Vote"].map((item) => (
                                <Tab key={item} as={Fragment}>
                                    {({ selected }) => (
                                        <button
                                            className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${selected
                                                ? "bg-primary-6000 text-secondary-50 "
                                                : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                                                } `}
                                        >
                                            {item}
                                        </button>
                                    )}
                                </Tab>
                            ))}
                            {/* <div style={{position:'absolute', right:10}}>
                                <button onClick={addProduct} className="rounded-full text-secondary-50" style={{backgroundColor:'#FAB005',padding:5, height:35, width:'35px'}}>+</button>
                            </div> */}
                        </Tab.List>
                        <Tab.Panels>
                            <Tab.Panel className="">
                                {showDataGiveaway()}
                            </Tab.Panel>
                            <Tab.Panel className="">
                                <div>
                                    <div className='flex justify-between mb-3'>
                                        <div className='flex items-center'>
                                            <span>Vote Available : {availableVote}</span>
                                        </div>
                                        {giveawayReducer?.giveawayDetail && (
                                            <ButtonSecondary disabled={loadingRefresh} className='py-2' onClick={() => refreshTable()}>
                                                {loadingRefresh ? (
                                                    <Loader
                                                        type="Circles"
                                                        color="#D24D29"
                                                        height={20}
                                                        width={20}
                                                    />
                                                ) : 'Refresh'}
                                            </ButtonSecondary>
                                        )}
                                    </div>

                                    {showListGiveaway()}
                                </div>
                            </Tab.Panel>

                        </Tab.Panels>
                    </Tab.Group>

                    {/* <div className="flex justify-end space-x-5 mt-3">
                    </div> */}
                </div>
            </div>
        )
    }

    const showDataGiveaway = () => {
        return (
            <div className="space-y-8">
                <FormItem
                    label="Name"
                    desc=""
                >
                    <Input placeholder="Insert your name" value={name} onChange={(e) => setName(e.target.value)} />
                </FormItem>
                <FormItem
                    label="Instagram"
                    desc=""
                >
                    <Input placeholder="Insert your instagram" value={instagram} onChange={(e) => setinstagram(e.target.value)} />
                </FormItem>
                <FormItem
                    label="Note"
                    desc=""
                >
                    <Textarea rows={2} placeholder={'Insert your note'} value={note} maxLength={150} onChange={(e) => {
                        setNote(e.target.value)

                    }} />
                    <span className='text-xs'>max 150 character</span>
                </FormItem>

                <div className="flex justify-end space-x-5 mt-3">
                    <ButtonPrimary onClick={submitdata}>
                        {loading === "submit" ? <div className="flex justify-center">
                            <Loader
                                type="Circles"
                                color="#fff"
                                height={25}
                                width={25}
                            />
                        </div> : 'Submit'}

                    </ButtonPrimary>
                </div>
                {giveawayReducer.giveawayJob == null ?
                    <div className='flex justify-center'>
                        <Loader
                            type="Circles"
                            color="#d24e29"
                            height={25}
                            width={25}
                        />
                    </div> : <div className='mt-5'>
                        {giveawayReducer?.giveawayData?.jobs && (
                            <div className='mb-2'>
                                <label>Jobs</label>
                            </div>
                        )}

                        {giveawayReducer?.giveawayData?.jobs && giveawayReducer?.giveawayData?.jobs.map((v: any, k: any) => (
                            FormJob(k, v, giveawayReducer?.giveawayJob)
                        ))}
                    </div>}
            </div>
        )
    }

    const showListGiveaway = () => {
        let column = [
            {
                name: 'Name',
                selector: (row: any) => row.name,
                sortable: true,
            },
            {
                name: 'Instagram',
                selector: (row: any) => row.account,
                sortable: true,
            },
            {
                name: 'Note',
                selector: (row: any) => row.note,
                sortable: true,
                wrap: true
            },
            {
                name: 'Vote',
                selector: (row: any) => row.userVote,
                sortable: true,
                width: '100px',
                cell: (row: any) => (
                    <div>
                        {row.userVote ? (
                            <>
                                {loadingVote == row.id ? (
                                    <Loader
                                        type="Oval"
                                        color="#d24e29"
                                        height={20}
                                        width={20}
                                    />
                                ) : (
                                    <HeartIcon className='w-7 h-7 cursor-pointer' style={{ color: '#FF0000' }} onClick={() => {

                                        if (loadingVote != null) {
                                            toast("Please wait")
                                            return false;
                                        }
                                        setLoadingVote(row.id)
                                        postVote(row.id, false)

                                    }} />
                                )}
                            </>
                        ) : (
                            <>
                                {loadingVote == row.id ? (
                                    <Loader
                                        type='Oval'
                                        height={20}
                                        width={20}
                                        color="#d24e29"
                                    />
                                ) : (
                                    <HeartIconOutline className='w-7 h-7 cursor-pointer' style={{ color: '#FF0000' }} onClick={() => {

                                        if (loadingVote != null) {
                                            toast("Please wait")
                                            return false;
                                        }
                                        setLoadingVote(row.id)

                                        postVote(row.id, true)
                                    }} />
                                )}
                            </>

                        )}
                    </div>
                ),
            },
        ]
        return (
            <div>
                {giveawayReducer?.giveawayDetail ? (
                    <TableCustom columns={column} data={giveawayReducer?.giveawayDetail?.vote} />
                ) : <></>}
            </div>
        )


    }





    const compressImage = async (event: any, useWebWorker: any) => {
        const file = event.target.files[0]

        if (file) {

            const targetName = useWebWorker ? 'webWorker' : 'mainThread'

            var options = {
                maxSizeMB: 0.5,
                maxWidthOrHeight: 1024,
                useWebWorker,
                onProgress: (p: any) => onProgress(p, useWebWorker)
            }
            const output = await imageCompression(file, options)
            setImageShow(URL.createObjectURL(file));
            setImageFile(output);

            setPrevImage({ ...prevImage, [nameJobImg]: URL.createObjectURL(file) })
        }

    }

    const onProgress = (p: any, useWebWorker: any) => {
        const targetName = useWebWorker ? 'webWorker' : 'mainThread'
    }


    const FormJob = (key: number, data: any, jobs: any) => {
        return (
            <form key={key} onSubmit={e => e.preventDefault()} style={{ marginTop: '0', marginBottom: '32px' }} noValidate>
                <FormItem
                    label={`${key + 1}. ${data?.job}`}
                    desc=""
                >
                    {data.type == 'text' ?
                        (
                            jobs?.[data.job] != null ?
                                <label>{jobs[data.job]?.['text']}</label> :
                                <Input placeholder={"Type your text"} onFocus={(e) => {
                                    settextJob(e.target.value);
                                    setnameJob(data.job);
                                    setTypeJob(data.type);
                                    setShowButton(key);
                                }} onChange={(e) => settextJob(e.target.value)} />
                        ) : (
                            <div>
                                {jobs?.[data.job] && <img src={jobs?.[data.job]?.text} alt='img' />}

                                {jobs?.[data.job] == null && (
                                    <>
                                        {/* <img src={jobs?.[data.job]?.text ?? imageShow} alt='img' /> */}
                                        {showPrevImg === key && <img src={imageShow} alt='img' />}

                                        <div className='flex justify-between'>
                                            <div>
                                                <label
                                                    htmlFor={`file-upload-${key}`}
                                                    className="relative cursor-pointer  rounded-md font-medium text-primary-6000 hover:text-primary-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500"
                                                >
                                                    <span>Upload File</span>
                                                    <input
                                                        id={`file-upload-${key}`}
                                                        name={`file-upload-${key}`}
                                                        type="file"
                                                        className="sr-only"
                                                        required={true}
                                                        accept='image/png, image/jpeg'

                                                        onChange={(event) => {
                                                            setImageShow(null);
                                                            setImageFile(null);
                                                            compressImage(event, false)
                                                            setnameJobImg(data.job);
                                                            setTypeJobImg(data.type);
                                                            setShowButton(null);
                                                            setshowPrevImg(key)
                                                        }}
                                                    />
                                                </label>
                                            </div>
                                            {showPrevImg === key && (
                                                <div>
                                                    <ButtonPrimary onClick={() => {
                                                        sendDataImage();
                                                    }} className=''>
                                                        {loading === "submitImg" ? <div className="flex justify-center">
                                                            <Loader
                                                                type="Circles"
                                                                color="#fff"
                                                                height={25}
                                                                width={25}
                                                            />
                                                        </div> : 'Save'}

                                                    </ButtonPrimary>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}

                            </div>
                        )}

                </FormItem>
                {showButton === key && (
                    <div className='flex justify-end mt-2'>
                        <ButtonPrimary onClick={sendData} className=''>
                            {loading === "submitJob" ? <div className="flex justify-center">
                                <Loader
                                    type="Circles"
                                    color="#fff"
                                    height={25}
                                    width={25}
                                />
                            </div> : 'Save'}

                        </ButtonPrimary>
                    </div>
                )}

            </form>
        )
    }

    return (
        <div
            className={`nc-PageJoinPartner container pb-24 lg:pb-32 ${className}`}
            data-nc-id="PageJoinPartner"
        >
            <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
                <div className="block flex-grow mb-24 lg:mb-0">
                    <div className="lg:sticky lg:top-24">{renderSidebar()}</div>
                </div>

                <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">

                    {/* {parseInt(user.credential.isGuide) === 0 && user.credential.guideDetail?.id ? pendingRegistration() : renderForm1()} */}
                    {giveawayReducer?.giveawayCheck == null ?
                        <div className='flex justify-center'>
                            <Loader
                                type="Circles"
                                color="#d24e29"
                                height={25}
                                width={25}
                            />
                        </div> : giveawayReducer?.giveawayCheck?.id ? renderPage2() : renderPage()}
                </div>
            </main>
            <ToastContainer position="bottom-right" />
            <NcModal
                isOpenProp={general.alert.show}
                renderTrigger={() => { return (<div></div>); }}
                renderContent={() => { return giveawayReducer.alert.content; }}
                onCloseModal={() => {
                    dispatch(showAlertGiveaway("", "", false))
                }}
                modalTitle={general.alert.title}
            />
        </div>
    )
}


export default PageGiveaway